import 'congress/css/congress.scss'

import gettext from 'gettext-congress'
import { createApp as createVueApp, defineAsyncComponent, type CreateAppFunction } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import { PageDataPlugin } from 'layout_congress/js/pageData.mts'
import PopupRouterLink from 'layout_congress/vue/PopupRouterLink.vue'
import { routes } from './vue/page/routes.mts'

export const App = defineAsyncComponent(() => import('./vue/App.vue'))

export const createApp: CreateAppFunction<Element> = (rootComponent, rootProps) => {
    const app = createVueApp(rootComponent, rootProps)

    const router = createRouter({
        history: createWebHistory(),
        routes,
    })
    app.use(router)
    app.use(PageDataPlugin)
    app.use(gettext)

    app.component('PopupRouterLink', PopupRouterLink)
    return app
}
